class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    this.toggleHeaderClass(true);

    if (group.classList.contains('header__menu-item--level-1')) {
      group.querySelector('.header__menu-link--level-1').setAttribute('aria-expanded', 'true');
    }
  }

  close(group) {
    super.close(group);
    this.toggleHeaderClass(false);

    if (group.classList.contains('header__menu-item--level-1')) {
      group.querySelector('.header__menu-link--level-1').setAttribute('aria-expanded', 'false');
    }
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      this.header.classList.add('header--is-open');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        this.header.classList.remove('header--is-open');
      }
    }
  }
}
class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.options.breakpoint = parseInt(1023);
    if (this.header) {
      // iPhone fix
      if (navigator.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    window.addEventListener('resize', this.onResize.bind(this));
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  onResize() {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth > this.options.breakpoint) {
      this.remove();
    }
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
    this.options.breakpoint = parseInt(1024);
  }

  construct() {
    super.construct();
    const { toggleClass, target } = this.options;
    this.searchInput = this.target?.querySelector('[data-autofocus]');
    this.closeButton = this.target?.querySelector('[data-close-button]');

    // key up escape
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // custom close button
    this.closeButton?.addEventListener('click', (e) => {
      this.preventDefault(e);
      this.stopPropagation(e);
      this.remove();
    });

    // click outside search
    document.addEventListener("click", (e) => {
      // if search is open
      if (this.target?.classList.contains(toggleClass)) {
        const isOutside = !e.target.closest(target);
        if (isOutside) {
          this.remove();
        }
      }
    });

    window.addEventListener('resize', this.onResize.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass, target } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  onResize() {
    this.windowWidth = window.innerWidth;

    if (this.windowWidth < this.options.breakpoint) {
      this.remove();
    }
  }

  add() {
    super.add();
    this.searchInput?.focus();
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.options = {};
    this.options.breakpoint = parseInt(1024);

    // select element
    this.header = document.querySelector('.shopify-section-group-header-group');
    this.headerWrapper = document.querySelector('.header');
    this.headerElement = this;
    this.headerHeight = this.headerElement?.offsetHeight;
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.searchToggle = this.querySelector('toggle-search');
    this.search = document.querySelector('[data-header-search]');

    this.collectionHeader = document.querySelector('.collection__header');

    this.collectionFilters = document.querySelector('.collection__filters');
    this.collectionFilterOptions = document.querySelector('.filter-options');
    this.mobileCountrySelect = document.querySelector('#mobile-country-select');

    if (this.header) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.headerElement) {
        this.scrollOffset += this.headerHeight;
      }

      // scroll event
      window.addEventListener('scroll', this.onScroll.bind(this), false);
      this.mobileCountrySelect?.addEventListener('change', this.changeLanguage);

    }
  }

  onScroll() {
    // when the bottom is reached, reveal the header. iOS hack so the elastic snapping doesn't force the header to show/hide randomly and displaying empty space in the process.
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && window.innerWidth <= 1024) {
      requestAnimationFrame(this.revealTop.bind(this));
      return
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop <= this.headerStart) {
      requestAnimationFrame(this.revealTop.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
      requestAnimationFrame(this.reveal.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    document.body.classList.add('shopify-section-header-hidden');
    this.header.classList.add('shopify-section-header-hidden');
    this.closeHeaderNav();
    this.closeSearch();

    if(this.collectionFilters) {
      this.collectionFilters.style.top = `0px`;
      this.collectionHeader.style.top = `0px`;
      this.collectionFilterOptions.style.maxHeight = `100vh`;
    }
  }

  reveal() {
    this.windowWidth = window.innerWidth;
    document.body.classList.remove('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-hidden');

    if(this.collectionFilters) {
      this.collectionFilters.style.top = `${this.headerHeight}px`;
      this.collectionHeader.style.top = `${this.headerHeight}px`;

      if (document.body.classList.contains('collection-filter-is-open')) {
        this.collectionFilterOptions.style.maxHeight = `100vh`;
      } else {
        if (this.windowWidth < this.options.breakpoint) {
          this.collectionFilterOptions.style.maxHeight = `100vh`;
        } else {
          this.collectionFilterOptions.style.maxHeight = `calc(100vh - ${this.headerHeight}px)`;
        }
      }
    }
  }

  revealTop() {
    document.body.classList.remove('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if(!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }

  changeLanguage(event) {
    event.preventDefault();
    window.location.href = this.options[this.selectedIndex].value
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
